module.exports = __webpack_public_path__ + "static/img/def.defb8d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chat/images/chat_files/def.png
// module id = 11MO
// module chunks = 1